import {
  FETCH_REPORT_REQUEST,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_FAILURE,
} from "../actions/attendanceReportActions";

const initialState = {
  reportData: [],
  meta: {},
  loading: false,
  error: null,
};

export default function attendanceReportReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        reportData: action.payload.data,
        meta: action.payload.meta,
      };
    case FETCH_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}